import { IndexableObjectType } from "component-library-and-tools/dist/types/commonTypes";
export const IS_LOGGED_IN_LOCALSTORAGE_KEY = 'TS_IS_LOGGED_IN';


/**
 * A quick helper to grab the csrf token from the cookie.
 */
export const getCsrfToken = () => parseCsrfToken(document.cookie);

/**
 * Parse CSRF token from a cookie string.
 */
export const parseCsrfToken = (cookies: string) => {
  const cookiesMap = cookies
    .split(';')
    .map(x => x.trim().split('='))
      /* Cookie comes as a string, so split up the string by '=' signs, as that seperates each value 
      and puts them into an array.
      */
    .reduce((a: IndexableObjectType, b: Array<string>) => {
      /*
        We then reduce the array into an object that serves as a map of keys and values
      */
      a[b[0]] = b[1]; 
      return a;
    }, {});
  return cookiesMap['XSRF-TOKEN'];
};


/** Request Headers Singleton 
 * Used by AJAX driver and allows us to change headers for all requests instead of adding more request interceptors
 * Can be extended in the future if more default headers needed
 * 
*/

let defaultHeaders: IndexableObjectType = {};

const DefaultHeadersObject = {
    getXsrf: () => defaultHeaders['X-XSRF-TOKEN'] || '',
    xsrf: (xsrfString: string) => defaultHeaders['X-XSRF-TOKEN'] = xsrfString,
    get: () => Object.assign({}, defaultHeaders),
};

Object.freeze(DefaultHeadersObject);
export {DefaultHeadersObject};
